<template>
  <div style="width: 100%;height: 100vh;overflow: hidden">
    <iframe :src="adminOrigin" style="width: 100%;height: 100%;border: none;"></iframe>
  </div>
</template>
<script>
import { ADMIN_ORIGIN } from '@/config/app.config'

export default {
  name: 'AdminLogin',
  data() {
    return {
      adminOrigin: ADMIN_ORIGIN
    }
  }
}
</script>
